<template>
  <div class="login-page">
    <img
      src="/static/domino.jpg"
      alt="background decoration"
      class="bg-decoration"
    />

    <b-container class="h-100 d-flex align-items-center justify-content-center">
      <div class="login-card">
        <div class="text-center mb-4">
          <div class="logo-container">
            <img src="/static/logo.svg" alt="Logo" class="logo-login"/>
          </div>
        </div>

        <b-alert
          variant="danger"
          class="custom-alert"
          dismissible
          :show="showDismissibleAlert"
          @dismissed="showDismissibleAlert = false"
        >
          {{ loginErrorMessage }}
        </b-alert>

        <b-form id="loginForm" @submit.stop.prevent="login" class="login-form">
          <h2 class="text-center mb-4 d-block">Войдите в аккаунт</h2>
          <b-form-group class="custom-group mb-4">
            <b-form-input
              id="usernameInput"
              v-model="username"
              type="text"
              :placeholder="$t('message.login.enterLogin')"
              class="custom-input"
            />
          </b-form-group>

          <b-form-group class="custom-group mb-2 position-relative">
            <b-form-input
              id="passwordInput"
              v-model="password"
              :type="isPasswordVisible ? 'text' : 'password'"
              :placeholder="$t('message.login.enterPassword')"
              class="custom-input"
            />
            <div class="password-toggle" @click="isPasswordVisible = !isPasswordVisible">
              <v-icon
                v-if="isPasswordVisible"
                name="buttons/eye"
                :size="16"
              />
              <v-icon
                v-else
                name="buttons/eyeClosed"
                :size="16"
              />
            </div>
          </b-form-group>

          <div class="password-description d-flex align-items-start mb-1 ml-3">
            <v-icon name="buttons/info" :size="12" class="me-2 mr-1" />
            <span>был выдан администратором, либо уже изменён вами в личном кабинете</span>
          </div>

          <div class="d-flex justify-content-end align-items-center mb-5">
            <b-form-checkbox v-model="rememberToken">
              Запомнить меня
            </b-form-checkbox>
          </div>

          <div class="text-center">
            <b-button type="submit" variant="dark" class="btn-submit">
              {{ $t("message.login.signIn") }}
            </b-button>
          </div>
        </b-form>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: "",
      password: "",
      isPasswordVisible: false,
      showDismissibleAlert: false,
      loginErrorMessage: "Доступ запрещён",
      rememberToken: false,
    };
  },
  mounted() {
    const savedUsername = localStorage.getItem('remembered_username');
    if (savedUsername) {
      this.username = savedUsername;
      this.rememberToken = true;
    }
  },
  methods: {
    login() {
      if (this.rememberToken) {
        localStorage.setItem('remembered_username', this.username);
      } else {
        localStorage.removeItem('remembered_username');
      }

      this.post("login", {
        username: this.username,
        password: this.password,
        rememberToken: this.rememberToken
      }, (result) => {
        if (result.status === 200) {
          this.$store.dispatch("login", {
            token: result.body.access_token,
            refreshToken: result.body.refresh_token,
            rememberToken: this.rememberToken
          }).then(() => {
            const storage = this.rememberToken ? localStorage : sessionStorage;
            storage.setItem('role', result.body.role);
            storage.setItem('permissions', result.body.permissions);
            this.userInfo(result.body.access_token, result.body.refresh_token);
          });
        }

        if (result.status === 401) {
          const isInactive = result.body && result.body.message === "user inactive";
          this.loginErrorMessage = isInactive ? "Пользователь неактивен": "Доступ запрещён";
          this.showDismissibleAlert = true;
        }
      });
    },

    post(url, data, callback) {
      return this.$http.post(url, data, null).then((result) => {
        callback(result);
      }).catch((error) => {
        callback(error);
      });
    },

    userInfo(token, refreshToken) {
      this.$http.get("users/info").then((result) => {
        if (result.status === 200) {
          this.$store.dispatch("login", {
            token: token,
            refreshToken: refreshToken,
            role: result.body.role,
            permissions: result.body.permissions,
          }).then(() => {
            const role = result.body.role;
            if (role === "accountant") {
              return;
            }
            if (role === "marketer") {
              this.$router.push({ name: "ManagerStatistics" }).catch(() => {});
              return;
            }
            this.$router.push('/').catch(() => {});
          });
        }
      }).catch((error) => {
        console.error("User info error:", error);
        if (error.status === 401 || error.status === 403) {
          this.showDismissibleAlert = true;
        }
      });
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style scoped>
.login-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #F5F5F5;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: 0;
  pointer-events: none;
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 480px;
  padding: 60px 40px;
  background: #FFFFFF;
  border-radius: 24px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
}

.logo-container {
  display: inline-block;
  background: #FFFFFF;
  width: 220px;
  height: auto;
}

.logo-login {
  width: 100%;
  height: auto;
  display: block;
}

.custom-input {
  background-color: #F5F6F6 !important;
  border: none !important;
  border-radius: 18px !important;
  height: 36px !important;
  padding: 0 20px !important;
  font-size: 14px;
}

.custom-input:focus {
  box-shadow: 0 0 0 2px rgba(26, 145, 103, 0.2) !important;
}

.password-description {
  font-size: 12px;
  text-align: left;
  line-height: 1.4;
}

.password-description .v-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.btn-submit {
  background-color: #1A9167 !important;
  border: none !important;
  border-radius: 18px !important;
  padding: 8px 50px !important;
  font-weight: 500;
  transition: opacity 0.2s ease;
}

.btn-submit:hover {
  opacity: 0.9;
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8E8E8E;
  transition: color 0.2s ease;
}

.password-toggle:hover {
  color: #1A9167;
}
</style>



// WEBPACK FOOTER //
// src/components/Authorization/Login.vue